import { jsxs as n, jsx as i } from "react/jsx-runtime";
import { Stack as l, Divider as o, Grid as s } from "@mui/material";
import { Button as p } from "./index26.mjs";
import { Typography as h } from "./index59.mjs";
import { useState as c } from "react";
import { CookieSection as a } from "./index327.mjs";
import { messages as t } from "./messages3.mjs";
const B = (v) => {
  const { locale: e, onSave: d } = v, [u, y] = c(!0), [m, C] = c(!0), [
    g,
    k
  ] = c(!0), [f, A] = c(!0);
  return /* @__PURE__ */ n(l, { gap: 3, paddingY: 3, children: [
    /* @__PURE__ */ n(l, { gap: 3, paddingX: 3, children: [
      /* @__PURE__ */ i(h.H5, { color: (r) => r.palette.text.primary, children: t.title[e] }),
      /* @__PURE__ */ n(l, { gap: 2, children: [
        /* @__PURE__ */ i(h.Body1, { color: (r) => r.palette.text.primary, children: t.description[e] }),
        /* @__PURE__ */ n(l, { gap: 1, children: [
          /* @__PURE__ */ i(
            a,
            {
              title: t.essentialTitle[e],
              description: t.essentialDescription[e],
              isAlwaysActive: !0,
              locale: e,
              value: !0
            }
          ),
          /* @__PURE__ */ i(o, {}),
          /* @__PURE__ */ i(
            a,
            {
              title: t.performanceTitle[e],
              description: t.performanceDescription[e],
              value: u,
              onChange: (r) => y(r),
              locale: e
            }
          ),
          /* @__PURE__ */ i(o, {}),
          /* @__PURE__ */ i(
            a,
            {
              title: t.functionalityTitle[e],
              description: t.functionalityDescription[e],
              value: m,
              onChange: (r) => C(r),
              locale: e
            }
          ),
          /* @__PURE__ */ i(o, {}),
          /* @__PURE__ */ i(
            a,
            {
              title: t.targetingAdvertisingTitle[e],
              description: t.targetingAdvertisingDescription[e],
              value: g,
              onChange: (r) => k(r),
              locale: e
            }
          ),
          /* @__PURE__ */ i(o, {}),
          /* @__PURE__ */ i(
            a,
            {
              title: t.socialMediaTitle[e],
              description: t.socialMediaDescription[e],
              value: f,
              onChange: (r) => A(r),
              locale: e
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ i(o, {}),
    /* @__PURE__ */ n(s, { container: !0, spacing: 2, paddingX: 3, children: [
      /* @__PURE__ */ i(s, { xs: 6, item: !0, children: /* @__PURE__ */ i(
        p,
        {
          variant: "primary",
          color: "primary",
          size: "medium",
          fullWidth: !0,
          onClick: () => {
            d({
              essential: !0,
              performance: !0,
              functionality: !0,
              targetingAdvertising: !0,
              socialMedia: !0
            });
          },
          children: t.acceptAllButton[e]
        }
      ) }),
      /* @__PURE__ */ i(s, { xs: 6, item: !0, children: /* @__PURE__ */ i(
        p,
        {
          variant: "primary",
          color: "primary",
          size: "medium",
          fullWidth: !0,
          onClick: () => {
            d({
              essential: !0,
              performance: !1,
              functionality: !1,
              targetingAdvertising: !1,
              socialMedia: !1
            });
          },
          children: t.rejectAllButton[e]
        }
      ) }),
      /* @__PURE__ */ i(s, { xs: 12, item: !0, children: /* @__PURE__ */ i(
        p,
        {
          variant: "tertiary",
          size: "medium",
          color: "primary",
          fullWidth: !0,
          onClick: () => d({
            essential: !0,
            performance: u,
            functionality: m,
            targetingAdvertising: g,
            socialMedia: f
          }),
          children: t.saveButton[e]
        }
      ) })
    ] })
  ] });
};
export {
  B as CookiesConsentManage
};
//# sourceMappingURL=index239.mjs.map
